/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';

export interface AuxMetricsExcelExportRetrieveRequest {
  assessmentId: number;
}

/**
 *
 */
export class AuxMetricsExcelExportApi extends runtime.BaseAPI {
  /**
   */
  async auxMetricsExcelExportRetrieveRaw(
    requestParameters: AuxMetricsExcelExportRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['assessmentId'] == null) {
      throw new runtime.RequiredError(
        'assessmentId',
        'Required parameter "assessmentId" was null or undefined when calling auxMetricsExcelExportRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/aux-metrics-excel-export/{assessment_id}/`.replace(
          `{${'assessment_id'}}`,
          encodeURIComponent(String(requestParameters['assessmentId'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async auxMetricsExcelExportRetrieve(
    requestParameters: AuxMetricsExcelExportRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.auxMetricsExcelExportRetrieveRaw(requestParameters, initOverrides);
  }
}
